import { mainApi } from "../api/api";
import { returnOrError, sleep } from "../misc/utils"
import { accessGlobalUserState } from "../stores/user";

const simpleGetter = async (apiFunction, params = {}) => {
    try {
        const res = await apiFunction(params)
        if (res.data?.message === 'WRONG_TOKEN') {
            const refreshResponse = await mainApi.refreshToken({
                refreshToken: accessGlobalUserState().get()?.refreshToken,
            });
            console.log('refresh response ', refreshResponse.data);
            if (refreshResponse.data?.accessToken) {
                accessGlobalUserState().mergeRoot({
                    token: refreshResponse.data.accessToken,
                    refreshToken: refreshResponse.data.refreshToken,
                });
                await sleep(500);
                const updatedRes = await apiFunction(params);
                return returnOrError(updatedRes.data);
            }
        }
        return returnOrError(res.data)
    } catch (e) {
        console.log(e)
        // Propagate backend error payload when available (e.g., { success:false, msg: 'files_required' })
        return e?.response?.data || {}
    }
}

export {
    simpleGetter
}